import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { UserInterests } from '../entities/user-interests.entity';

export const DepotActions = createActionGroup({
  source: 'Depot',
  events: {
    'Load User Interests': props<{ force?: boolean }>(),
    'Dismiss Savings Plan Teaser': emptyProps(),
    'Activate Direct Debit': emptyProps(),
  },
});

export const DepotApiActions = createActionGroup({
  source: 'Depot API',
  events: {
    'Load User Interests Success': props<{ userInterests: UserInterests }>(),
    'Load User Interests Failure': props<{ error: HttpErrorResponse }>(),
    'Dismiss Savings Plan Teaser Success': emptyProps(),
    'Dismiss Savings Plan Teaser Failure': props<{ error: HttpErrorResponse }>(),
    'Activate Direct Debit Success': emptyProps(),
    'Activate Direct Debit Failure': props<{ error: HttpErrorResponse }>(),
  },
});
